import { Spin } from "antd";
import { useEffect, useState } from "react";
import { IoIosWarning } from "react-icons/io";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import Breadcrumb from "Components/Breadcrums";
import FormControl from "Components/FormControl";
import { showErrorAlert, showWarningAlert, Toast } from "Util/Alerts";

import { breadcrumbItems } from "./Constant";
import { campaignsInputs } from "./Types";
import {
    add_campaigns,
    update_campaigns,
    Get_category_campaigns,
    searchGiveawayProducts,
    Get_category,
    getPorductDetailsSku,
} from "Services/Requests";
import Styles from "Styles/Styles.module.css";
import { options } from "./Types";
import Select from "react-select";
import { categoryType } from "Pages/Auth/Category/Types";
import { campaignCategories } from "./Types";
import { giveawayproductsType } from "Pages/Auth/Prizes/Types";

window.Buffer = window.Buffer || require("buffer").Buffer;

function Addcampaigns() {
    const navigate = useNavigate();
    const { type } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    const [selectedProduct, setselectedProduct] = useState<any>();
    const [Products, setProducts] = useState<options[]>([]);
    const [ProductSearchLoad, setProductSearchLoad] = useState(false);
    const [ProductString, setProductString] = useState("");

    const [selectedCampaign, setselectedCampaign] = useState<any>();
    const [Campaign, setCampaign] = useState<options[]>([]);
    const [CampaignSearchLoad, setCampaignSearchLoad] = useState(false);
    const [CampaignString, setCampaignString] = useState("");

    const [campaigns, setcampaigns] = useState<options[]>([]);
    const [ErrorMsg, setErrorMsg] = useState<null | string>(null);
    const [category, setcategory] = useState<options[]>([]);

    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
        watch,
        setValue,
    } = useForm<campaignsInputs>({
        defaultValues: {},
    });

    const onSubmit: SubmitHandler<campaignsInputs> = async (data) => {
        if (!selectedProduct?.value) {
            setErrorMsg("Please Select Product");
            return;
        }
        if (!selectedCampaign?.value) {
            setErrorMsg("Please Select Prize");
            return;
        }
        let body = {
            ...data,
            giveaway_product_id: selectedCampaign?.value,
            product_id: selectedProduct?.product_id,
            category_id: selectedProduct.catId,
            is_exclusive: data?.is_exclusive ? 1 : 0,
        };
        try {
            setLoading(true);
            let response;
            if (type === "edit") {
                response = await update_campaigns(location.state?.campaign_id, {
                    ...body,
                });
            } else {
                response = await add_campaigns(body);
            }
            if (response?.data?.status === 1) {
                Toast(response?.data?.Message, "success");
                navigate(-1);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong, try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const watchData = watch();

    const getApi = async () => {
        try {
            const [response1] = await Promise.all([Get_category_campaigns()]);
            if (response1?.data?.status === 1) {
                setcampaigns(
                    response1?.data?.campaignCategories?.map(
                        (item: campaignCategories) => ({
                            value: item.campaign_category_id,
                            label: item.campaign_category_name,
                        })
                    )
                );

                if (type === "edit") {
                    setselectedProduct({
                        value: location.state.sku,
                        product_id: location?.state?.product_id,
                        label: location?.state?.sku,
                        product_name: location?.state?.product_name,
                        catName: location?.state?.category_name,
                        catId: location?.state?.category_id,
                    });
                    setselectedCampaign({
                        value: location.state.giveaway_product_id,
                        label: location?.state?.giveaway_product_name,
                    });
                    let prevData = location.state;
                    reset({
                        giveaway_product_id: prevData?.giveaway_product_id,
                        telegram_link: prevData?.telegram_link,
                        category_id: prevData?.category_id,
                        campaign_category_id: prevData?.campaign_category_id,
                        campaign_stock: prevData?.campaign_stock,
                        is_exclusive:
                            prevData?.is_exclusive == 1 ? true : false,
                    });
                }
            }
        } catch (err) {
            showErrorAlert("Something went wrong, try again later");
            setLoading(false);
        }
    };
    useEffect(() => {
        getApi();
    }, [type, location.state, reset]);

    useEffect(() => {
        const debouncedSearch = setTimeout(async () => {
            if (typeof ProductString == "string" && ProductString?.length > 0) {
                setProductSearchLoad(true);

                try {
                    const data = await getPorductDetailsSku({
                        sku: ProductString,
                    });
                    const formattedOptions = data?.data.data?.map(
                        (product: any) => ({
                            label: `${product.sku}`,
                            value: product?.sku,
                            catId: product?.category_id,
                            catName: product?.category_name,
                            product_id: product?.product_id,
                            product_name: product?.product_name,
                        })
                    );
                    setProducts(formattedOptions);
                } catch (error) {
                    console.error("Error fetching options:", error);
                } finally {
                    setProductSearchLoad(false);
                }
            }
        }, 300);

        return () => clearTimeout(debouncedSearch);
    }, [ProductString]);

    useEffect(() => {
        const debouncedSearch = setTimeout(async () => {
            if (
                typeof CampaignString == "string" &&
                CampaignString?.length > 0
            ) {
                setCampaignSearchLoad(true);

                try {
                    const data = await searchGiveawayProducts({
                        search_term: CampaignString,
                    });
                    const formattedOptions = data?.data.data?.map(
                        (product: any) => ({
                            label: `${product.giveaway_product_name}`,
                            value: product?.giveaway_product_id,
                        })
                    );
                    setCampaign(formattedOptions);
                } catch (error) {
                    console.error("Error fetching options:", error);
                } finally {
                    setCampaignSearchLoad(false);
                }
            }
        }, 300);

        return () => clearTimeout(debouncedSearch);
    }, [CampaignString]);

    const handleProductChange = (searchString: string) => {
        setProductString(searchString);
    };
    const onproductSelect = (searchString: string) => {
        setselectedProduct(searchString);
        // setValue('product_id',searchString.value)
    };
    const handleCampaignChange = (searchString: string) => {
        setCampaignString(searchString);
    };
    const onCampaignSelect = (searchString: string) => {
        setselectedCampaign(searchString);
    };
    return (
        <div className={Styles["Add_form_wrapper"]}>
            <h3>
                <span style={{ textTransform: "capitalize" }}>{type}</span>{" "}
                campaign
            </h3>
            <Breadcrumb items={breadcrumbItems} type={type} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={Styles["form"]}>
                    <h4>campaigns</h4>
                    <div className={Styles["form_control_select"]}>
                        <label>
                            Sku
                            <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                            onInputChange={handleProductChange}
                            value={selectedProduct}
                            onChange={onproductSelect}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    height: 40, // Adjust height
                                    border: "1px solid #e0e2e7",

                                    minHeight: 30, // Ensure a minimum height
                                    padding: "0 8px", // Adjust padding to reduce control height
                                    borderRadius: 4, // Optional: ensure rounded corners
                                    overflow: "hidden", // Prevent overflowing text
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    padding: "0 8px", // Adjust padding inside the value container
                                    maxWidth: "100%", // Make sure it respects the width
                                    whiteSpace: "nowrap", // Prevent wrapping of the value
                                    overflow: "hidden", // Hide the overflow
                                    textOverflow: "ellipsis", // Add ellipsis if the text overflows
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    whiteSpace: "nowrap", // Prevent wrapping
                                    overflow: "hidden", // Hide the overflow
                                    textOverflow: "ellipsis", // Add ellipsis for overflowing text
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: 4, // Reduce padding around the dropdown arrow
                                }),
                                clearIndicator: (base) => ({
                                    ...base,
                                    padding: 4, // Reduce padding around the clear indicator
                                }),
                                option: (base) => ({
                                    ...base,
                                    padding: 8, // Adjust padding for option height
                                }),
                                menu: (base) => ({
                                    ...base,
                                    marginTop: 0, // Reduce space between the control and the options
                                }),
                            }}
                            options={Products}
                            isLoading={ProductSearchLoad}
                            placeholder="Search SKU"
                            // getOptionLabel={(e: any) => e.label}
                        />
                    </div>

                    <div className={Styles["form_control"]}>
                        <label htmlFor="">Product</label>
                        <input
                            type="text"
                            disabled
                            value={selectedProduct?.product_name}
                        />
                    </div>
                    <div className={Styles["form_control"]}>
                        <label htmlFor="">Category</label>
                        <input
                            type="text"
                            disabled
                            value={selectedProduct?.catName}
                        />
                    </div>
                    <div className={Styles["form_control_select"]}>
                        <label>
                            Prize
                            <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                            onInputChange={handleCampaignChange}
                            value={selectedCampaign}
                            onChange={onCampaignSelect}
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    height: 40, // Adjust height
                                    border: "1px solid #e0e2e7",

                                    minHeight: 30, // Ensure a minimum height
                                    padding: "0 8px", // Adjust padding to reduce control height
                                    borderRadius: 4, // Optional: ensure rounded corners
                                    overflow: "hidden", // Prevent overflowing text
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    padding: "0 8px", // Adjust padding inside the value container
                                    maxWidth: "100%", // Make sure it respects the width
                                    whiteSpace: "nowrap", // Prevent wrapping of the value
                                    overflow: "hidden", // Hide the overflow
                                    textOverflow: "ellipsis", // Add ellipsis if the text overflows
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    whiteSpace: "nowrap", // Prevent wrapping
                                    overflow: "hidden", // Hide the overflow
                                    textOverflow: "ellipsis", // Add ellipsis for overflowing text
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: 4, // Reduce padding around the dropdown arrow
                                }),
                                clearIndicator: (base) => ({
                                    ...base,
                                    padding: 4, // Reduce padding around the clear indicator
                                }),
                                option: (base) => ({
                                    ...base,
                                    padding: 8, // Adjust padding for option height
                                }),
                                menu: (base) => ({
                                    ...base,
                                    marginTop: 0, // Reduce space between the control and the options
                                }),
                            }}
                            options={Campaign}
                            isLoading={CampaignSearchLoad}
                            placeholder="Search Prize"
                            getOptionLabel={(e: any) => e.label}
                        />
                    </div>
                    <FormControl
                        key={"campaign_category_id"}
                        label={"Campaign Tag"}
                        name={"campaign_category_id"}
                        register={register}
                        errors={errors["campaign_category_id"]}
                        type={"select"}
                        options={campaigns}
                    />
                    {/*  <FormControl
                        key={"Category"}
                        label={"Category"}
                        name={"category_id"}
                        register={register}
                        errors={errors["category_id"]}
                        type={"select"}
                        options={category}
                        isDisabled
                    /> */}
                    <FormControl
                        key={"Campaign Stock"}
                        label={"Campaign Stock"}
                        name={"campaign_stock"}
                        register={register}
                        errors={errors["campaign_stock"]}
                        type={"number"}
                        // options={campaigns}
                    />
                    <FormControl
                        key={"Telegram Link"}
                        label={"Telegram Link"}
                        name={"telegram_link"}
                        register={register}
                        errors={errors["telegram_link"]}
                        type={"text"}
                        requiredMessage="This is required"
                        // options={campaigns}
                    />
                    <div className={Styles["form_control_check_box"]}>
                        <input
                            type="checkbox"
                            {...register("is_exclusive")}
                            id="size"
                            defaultChecked={watchData?.is_exclusive}
                        />
                        <label htmlFor="size">Exclusive Campaign?</label>
                    </div>

                    {ErrorMsg && (
                        <p className={Styles["Gen-erro_msg"]}>
                            <IoIosWarning /> {ErrorMsg}
                        </p>
                    )}
                </div>

                {loading ? (
                    <Spin size="default" />
                ) : (
                    <button>{type === "edit" ? "Update" : "Add"}</button>
                )}
            </form>
        </div>
    );
}

export default Addcampaigns;
